import { render, staticRenderFns } from "./solar-loader.vue?vue&type=template&id=68492b86"
import script from "./solar-loader.vue?vue&type=script&lang=js"
export * from "./solar-loader.vue?vue&type=script&lang=js"
import style0 from "./solar-loader.vue?vue&type=style&index=0&id=68492b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports